export default __webpack_public_path__ + "static/media/img-proj-banpu-power.0c6762c6.png";